<template>
	<div class="box">
		<div class="box-header">
			<h2 class="box-title" v-if="tankGroup.id">Edit Tank Group</h2>
			<h2 class="box-title" v-else>Create New Tank Group</h2>
		</div>
		<div class="box-body">

			<div class="margin-20"></div>

			<form class="form-horizontal" @submit="saveOrCreate()">
				<fieldset>
					<input-text name="name" label="Group Name" :vmodel.sync="tankGroup.name"></input-text>
				</fieldset>
			</form>

			<div v-if="tankGroup.id">
				<a @click="destroy()" class="btn btn-danger"><i class="fa fa-close"></i> Delete Tank Group</a>
			</div>
		</div>
	</div>
</template>

<script>
	import { TankGroups as TankGroupActions } from 'vx/actions'
	import { site, tankGroup as activeTankGroup } from 'vx/getters'
	import { validate } from 'utils/validator'
	import Notify from 'utils/notify'
	import Alert from 'utils/alert'

	export default {
		props: ['tankGroup', 'justRepositioned'],

		data() {
			return {
				validation: {
					rules: {
						name: 'required'
					}
				},
				saveTimeout: null
			}
		},

		vuex: {
			actions: {
				storeTankGroup: TankGroupActions.store,
				updateTankGroup: TankGroupActions.update,
				destroyTankGroup: TankGroupActions.destroy,
				clearTankGroup: TankGroupActions.clear,
				allTankGroups: TankGroupActions.all
			},
			getters: {
				site,
				activeTankGroup
			}
		},

		watch: {
			tankGroup: {
				handler(newTankGroup, oldTankGroup) {
					if (! newTankGroup.name || newTankGroup.id != oldTankGroup.id || this.justRepositioned) {
						this.justRepositioned = false;

						return;
					}

					clearTimeout(this.saveTimeout);

					this.saveTimeout = setTimeout(() => {
						this.saveOrCreate();
					}, 1250);
				},
				deep: true
			}
		},

		methods: {
			validate,

			saveOrCreate() {
				if (this.tankGroup.id) {
					this.save();
				} else {
					this.create();
				}
			},

			create() {
				this.validate(this.tankGroup, this.validation.rules).passes(() => {
					this.storeTankGroup(this.site.id, this.tankGroup.name).then(response => {
						Notify.success('New tank group added.');
					});
				});
			},

			save() {
				this.validate(this.tankGroup, this.validation.rules).passes(() => {
					this.updateTankGroup(this.site.id, this.tankGroup).then(response => {
						Notify.success('Tank group updated.');
					})
				});
			},

			destroy() {
				if (this.tankGroup.fermenters && this.tankGroup.fermenters.data.length > 0) {
					Alert.error({ text: 'This tank group has existing fermenters. Please move or delete the fermenters before you continue.' });

					return;
				}

				let self = this;

				Alert.delete({
					showLoaderOnConfirm: true,
					preConfirm() {
						return self.destroyTankGroup(self.site.id, self.tankGroup.id);
					}
				}).then(() => {
					this.clearTankGroup();

					Alert.success({ text: 'Tank group has been deleted.' }).then(() => {}, () => {});
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// tank-groups-form.vue?4e327c3e